export default __webpack_public_path__ + "static/media/order-of-commitment.2d9fba84.svg";